import { render } from "./VisitorMatrixSetting.vue?vue&type=template&id=5a559a5a&scoped=true"
import script from "./VisitorMatrixSetting.vue?vue&type=script&lang=js"
export * from "./VisitorMatrixSetting.vue?vue&type=script&lang=js"

import "./VisitorMatrixSetting.vue?vue&type=style&index=0&id=5a559a5a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a559a5a"]])

export default __exports__